import { render } from "./VButton.vue?vue&type=template&id=54851a1e&scoped=true"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"

import "./VButton.vue?vue&type=style&index=0&id=54851a1e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54851a1e"]])

export default __exports__